import * as React from 'react';
import FormGroupWithInput from '@reverbdotcom/commons/dist/components/form_group_with_input';

export default function CurrenciesInputs({ currencyValues, setCurrencyValues, disabled }) {
  return (
    <div className="mb-3">
      <h3 className="mb-2">Currencies</h3>
      {currencyValues.map(currencyValue => {
        const { currency, amount, minPurchaseAmount } = currencyValue;

        return (
          <div className="d-flex" key={currency}>
            <div className="mr-5 d-flex fx-align-center" style={{ width: '5rem' }}>
              <h4>{currency}</h4>
            </div>
            <div className="mr-5 mb-1">
              <FormGroupWithInput
                inputName={`${currency}-amount`}
                label="Amount"
                value={amount}
                disabled={disabled}
                required
                tagRequired
                updateField={
                  (fieldUpdate) => {
                    const updatedValues = currencyValues.map(val => {
                      if (val.currency === currency) {
                        return { ...val, amount: fieldUpdate[`${currency}-amount`] };
                      }
                      return val;
                    });

                    setCurrencyValues(updatedValues);
                  }
                }
              />
            </div>
            <div className="mb-1">
              <FormGroupWithInput
                inputName={`${currency}-minPurchaseAmount`}
                label="Min Purchase Amount"
                value={minPurchaseAmount}
                required
                tagRequired
                disabled={disabled}
                updateField={
                  (fieldUpdate) => {
                    const updatedValues = currencyValues.map(val => {
                      if (val.currency === currency) {
                        return { ...val, minPurchaseAmount: fieldUpdate[`${currency}-minPurchaseAmount`] };
                      }
                      return val;
                    });

                    setCurrencyValues(updatedValues);
                  }
                }
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
